export enum SelectorDisplaySize {
	RESPONSIVE = 'responsive',
	EQUAL_SIZE = 'equal-size',
	JUSTIFY = 'justify'
}
